export const getAllProfiles = () => {
  return `
    SELECT 
      Id,
      Name
    FROM 
      Profile
    ORDER BY
      Name
      `;
};
